import angular from 'angular';
import crmConfirmation from './crmConfirmation';
import './style.scss';

export default angular
  .module('components.crmConfirmation', [])
  .component('crmConfirmation', crmConfirmation).name;
